import { Avatar, Box } from "@mui/material";
import React from "react";

interface PreviewAvatarImageProps {
  /**
   * An image as a base64 encoded string.
   */
  image: string;
  /**
   * If `true`, the component is shown.
   * @default true
   */
  isOpen?: boolean;
}

export default function PreviewAvatarImage(props: PreviewAvatarImageProps): React.JSX.Element {
  const isOpen = props.isOpen !== undefined ? props.isOpen : true;
  
  return (
    <Box
      sx={{
        display: isOpen ? "flex" : "none",
        justifyContent: "center"
      }}>
      <Avatar src={props.image} sx={{width: 256, height: 256}} />
    </Box>
  );
}